<template>
  <div v-loading="loading">
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">设备编号：</div>
        <el-input
          placeholder="请输入设备编号"
          size="medium"
          v-model="queryDevice.devNo"
          @change="getDevice()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位卡片区域 -->
      <div class="leftBox">
        <!-- 单位树 -->
        <el-tree
          class="treeBox"
          :data="depTrees"
          :props="defaultTreesProps"
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <!-- 右边单位卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加设备按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddDeviceDialogVisible = true"
          >
            新增
          </el-button>
          <!-- 设备信息表格区域 -->
          <el-table
            :data="deviceList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center'
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
          >
            <el-table-column prop="devNo" label="设备编号"> </el-table-column>
            <el-table-column prop="devType" label="设备类型">
              <template v-slot="devTypeSlot">
                <span v-show="devTypeSlot.row.devType == 1">执法仪</span>
                <span v-show="devTypeSlot.row.devType == 2">布控球</span>
                <span v-show="devTypeSlot.row.devType == 3">安全帽</span>
                <span v-show="devTypeSlot.row.devType == 4">无人机</span>
                <span v-show="devTypeSlot.row.devType == 5">摄像机</span>
                <span v-show="devTypeSlot.row.devType == 6">智能广播</span>
              </template>
            </el-table-column>
            <el-table-column prop="devType" label="协议类型">
              <template v-slot="devTypeSlot">
                <span v-show="devTypeSlot.row.devProtocol == 1">私有协议</span>
                <span v-show="devTypeSlot.row.devProtocol == 2">国标协议</span>
              </template>
            </el-table-column>
            <el-table-column prop="empName" label="使用人员"> </el-table-column>
            <el-table-column prop="depName" label="所属项目"> </el-table-column>
            <el-table-column prop="devPositionMonitorEnable" label="位置监听">
              <template v-slot="devPositionMonitorStateSlot">
                <span
                  v-show="
                    devPositionMonitorStateSlot.row.devPositionMonitorEnable ==
                      false
                  "
                  >关闭</span
                >
                <span
                  v-show="
                    devPositionMonitorStateSlot.row.devPositionMonitorEnable ==
                      true
                  "
                  >开启</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="devPositionMonitorTime"
              label="位置监听时间（分）"
            >
            </el-table-column>
            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <!-- <i class="el-icon-edit" style="font-size: 20px; color: rgb(53, 198, 224);  cursor: pointer;" @click="OpenUpdateDevicesDialog(slot.row)"></i> -->
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="OpenUpdateDevicesDialog(slot.row)"
                  ></el-button>
                </el-tooltip>
                <!-- <el-divider direction="vertical"></el-divider> -->
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <!-- <i class="el-icon-delete" style="font-size: 20px; color: red;" @click="deleteDevices(slot.row)"></i> -->
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deleteDevices(slot.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryDevice.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryDevice.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加设备信息对话框 -->
    <el-dialog
      title="新增设备"
      :visible.sync="AddDeviceDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddDeviceDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addDeviceFormRef"
        :rules="AddDeviceRules"
        :model="AddDevicesInfo"
        label-width="100px"
        label-position="right"
      >
        <el-form-item prop="devNo" label="设备编号">
          <el-input
            placeholder="请输入设备编号"
            v-model="AddDevicesInfo.devNo"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="devType" label="设备类型">
          <el-select
            v-model="AddDevicesInfo.devType"
            clearable
            placeholder="请选择设备类型"
          >
            <el-option
              v-for="item in devType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="devProtocol" label="协议类型">
          <el-select
            v-model="AddDevicesInfo.devProtocol"
            clearable
            placeholder="请选择协议类型"
          >
            <el-option
              v-for="item in devProtocol"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="devDepId" label="项目筛选">
          <el-select
            v-model="AddDevicesInfo.devDepId"
            placeholder="可根据项目筛选所在项目及其子项目下面的人员"
            ref="MySelect"
            @blur="clearUserInfo"
            @focus="clearUserInfo"
          >
            <el-option
              :key="AddDevicesInfo.devDepId"
              :label="checkDname"
              :value="AddDevicesInfo.devDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick2"
            >
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item prop="devEmpId" label="使用人员">
          <el-select
            v-model="AddDevicesInfo.devEmpId"
            filterable
            placeholder="请选择使用人员"
            @click.native="GetPerson()"
          >
            <el-option
              v-for="item in personList"
              :key="item.empId"
              :label="item.empName"
              :value="item.empId"
              @click.native="getDepId(item.empDepId)"
            >
            </el-option>
            <!-- </div> -->
          </el-select>
        </el-form-item>
        <el-form-item prop="devPositionMonitorEnable" label="位置监听开关">
          <el-select
            v-model="AddDevicesInfo.devPositionMonitorEnable"
            clearable
            placeholder="请选择位置监听是否开关"
          >
            <el-option
              v-for="item in PositionMonitorState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="devPositionMonitorTime" label="位置监听时间">
          <el-input
            type="number"
            placeholder="请输入位置监听时间（分钟）"
            v-model="AddDevicesInfo.devPositionMonitorTime"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddDeviceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddDevice()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改设备信息对话框 -->
    <el-dialog
      title="修改设备信息"
      :visible.sync="UpdateDeviceDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateDeviceDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="UpdateDeviceFormRef"
        :rules="UpdateUserRules"
        :model="UpdateDeviceInfo"
        label-width="100px"
        label-position="right"
      >
        <el-form-item prop="devNo" label="设备编号">
          <el-input
            placeholder="请输入设备编号"
            v-model="UpdateDeviceInfo.devNo"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="devType" label="设备类型">
          <el-select
            v-model="UpdateDeviceInfo.devType"
            clearable
            placeholder="请选择设备类型"
          >
            <el-option
              v-for="item in devType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="devProtocol" label="协议类型">
          <el-select
            v-model="UpdateDeviceInfo.devProtocol"
            clearable
            placeholder="请选择协议类型"
          >
            <el-option
              v-for="item in devProtocol"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="devDepId" label="项目筛选">
          <el-select
            v-model="UpdateDeviceInfo.devDepId"
            placeholder="可根据项目筛选所在项目及其子项目下面的人员"
            ref="MyUpdateSelect"
            @blur="clearUserInfo"
            @focus="clearUserInfo"
          >
            <el-option
              :key="UpdateDeviceInfo.devDepId"
              :label="checkDeviceDep"
              :value="UpdateDeviceInfo.devDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick3"
            >
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item prop="devEmpId" label="使用人员">
          <el-select
            v-model="UpdateDeviceInfo.devEmpId"
            filterable
            placeholder="请选择使用人员"
            @click.native="GetPerson()"
          >
            <el-option
              v-for="item in personList"
              :key="item.empId"
              :label="item.empName"
              :value="item.empId"
              @click.native="getDepIdAsUpdate(item.empDepId)"
            >
            </el-option>
            <!-- </div> -->
          </el-select>
        </el-form-item>
        <el-form-item prop="devPositionMonitorEnable" label="位置监听开关">
          <el-select
            v-model="UpdateDeviceInfo.devPositionMonitorEnable"
            clearable
            placeholder="请选择位置监听是否开关"
          >
            <el-option
              v-for="item in PositionMonitorState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="devPositionMonitorTime" label="位置监听时间">
          <el-input
            type="number"
            placeholder="请输入位置监听时间（分钟）"
            v-model="UpdateDeviceInfo.devPositionMonitorTime"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateDeviceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="UpdateDevices()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 设备信息
      deviceList: [],
      // 条件查询设备信息
      queryDevice: {
        // 设备编号
        devNo: "",
        // 单位节点ID
        depId: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10
      },
      // 总数
      total: 0,
      // 单位树信息
      depTrees: [],
      defaultTreesProps: {
        children: "depChilds",
        label: "depName"
      },
      // 获取到的人员信息
      personList: [],
      // 查询用户信息参数
      queryInfo: {
        // 单位ID
        depId: "",
        // 当前页码
        page: 1,
        // 每一页多少条
        pageSize: 99999
      },
      // 人员总数
      userTotal: 0,
      // 控制添加设备对话框的显示和隐藏
      AddDeviceDialogVisible: false,
      // 设备类型
      devType: [
        {
          value: "1",
          label: "执法仪"
        },
        {
          value: "2",
          label: "布控球"
        },
        {
          value: "3",
          label: "安全帽"
        },
        {
          value: "4",
          label: "无人机"
        },
        {
          value: "5",
          label: "摄像机"
        },
        {
          value: "6",
          label: "智能广播"
        }
      ],
      // 设备类型
      devProtocol: [
        {
          value: 1,
          label: "私有协议"
        },
        {
          value: 2,
          label: "国标协议"
        }
      ],
      //位置监听开关
      PositionMonitorState: [
        {
          value: true,
          label: "开启监听"
        },
        {
          value: false,
          label: "关闭监听"
        }
      ],
      loading: true,
      // 添加设备信息
      AddDevicesInfo: {
        // 设备编号
        devNo: "",
        // 设备类型
        devType: "",
        // 设备协议
        devProtocol: "",
        // 位置监听开关
        devPositionMonitorEnable: "",
        // 位置监听扫描时间
        devPositionMonitorTime: "",
        // 所属单位ID
        devDepId: "",
        // 人员ID
        devEmpId: ""
      },
      // 查询权限信息
      queryRole: {
        // 角色名称
        roleName: ""
      },
      checkDname: "",
      // 权限信息
      roleList: "",

      // 控制修改设备对话框的显示和隐藏
      UpdateDeviceDialogVisible: false,

      // 修改设备信息
      UpdateDeviceInfo: {
        // 设备编号
        devNo: "",
        // 设备类型
        devType: "",
        // 设备协议
        devProtocol: "",
        // 位置监听开关
        devPositionMonitorEnable: "",
        // 位置监听扫描时间
        devPositionMonitorTime: "",
        // 所属单位ID
        devDepId: "",
        // 人员ID
        devEmpId: ""
      },
      // 修改时默认选中的单位名称
      checkDeviceDep: "",
      // 修改时默认选中的人员名称
      checkUser: "",
      // departmentName: "",
      // 添加设备验证规则
      AddDeviceRules: {
        devNo: [
          { required: true, message: "设备编号必须填写", trigger: "blur" }
        ],

        devType: [
          { required: true, message: "设备类型必须选择", trigger: "change" }
        ],
        devProtocol: [
          { required: true, message: "协议类型必须选择", trigger: "change" }
        ],
        devEmpId: [
          { required: true, message: "使用人员必须选择", trigger: "change" }
        ]
      },

      // 修改用户验证规则
      UpdateUserRules: {
        devNo: [
          { required: true, message: "设备编号必须填写", trigger: "blur" }
        ],

        devType: [
          { required: true, message: "设备类型必须选择", trigger: "change" }
        ],
        devProtocol: [
          { required: true, message: "协议类型必须选择", trigger: "change" }
        ],
        devEmpId: [
          { required: true, message: "使用人员必须选择", trigger: "change" }
        ]
      }
    };
  },
  mounted() {
    this.getDevice();
    this.GetAllDepTrees();
    // this.getRole();
  },
  computed: {},
  methods: {
    // 获取设备信息
    async getDevice() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/device/search`,
        {
          params: this.queryDevice
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.loading = false;
      this.deviceList = res.data.rows;
      this.total = res.data.total;
    },
    // 获取全部单位树
    async GetAllDepTrees() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/department/getDepTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depTrees = res.data;
    },
    handleNodeClick(data) {
      this.queryDevice.depId = data.depId;
      this.getDevice();
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryDevice.pageSize = size;
      this.getDevice();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryDevice.page = current;
      this.getDevice();
    },

    // 分页查询人员信息
    async GetPerson() {
      const { data: res } = await this.$axios.get(`${this.$api}/emp/search`, {
        params: this.queryInfo
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.personList = res.data.rows;
      // 人员总数
      this.userTotal = res.data.total;
    },

    // 当选中单位时触发
    handleNodeClick2(data) {
      this.AddDevicesInfo.devDepId = data.depId;
      this.queryInfo.depId = data.depId;
      this.checkDname = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MySelect.handleClose();
    },

    // 获取权限信息  (因为后端没有查询所有角色，所有分页默认显示1000条，超出1000条后面的就查不到)
    async getRole() {
      const { data: res } = await this.$axios.get(`${this.$api}/role/search`, {
        params: this.queryRole
      });

      this.roleList = res.data.rows;
    },

    // 添加时点击查询对应人员的单位
    getDepId(empDepId) {
      this.AddDevicesInfo.devDepId = empDepId;
    },

    // 添加设备时，点击下拉选框和离开时触发此方法
    clearUserInfo() {
      this.personList = [];
      this.AddDevicesInfo.devEmpId = "";
      this.UpdateDeviceInfo.devEmpId = "";
    },
    // 添加设备信息
    async AddDevice() {
      this.$refs.addDeviceFormRef.validate(async valid => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/device/add`,
          {
            devNo: this.AddDevicesInfo.devNo,
            devType: this.AddDevicesInfo.devType,
            devProtocol: this.AddDevicesInfo.devProtocol,
            devDepId: this.AddDevicesInfo.devDepId,
            devEmpId: this.AddDevicesInfo.devEmpId,
            devPositionMonitorEnable: this.AddDevicesInfo
              .devPositionMonitorEnable,
            devPositionMonitorTime: this.AddDevicesInfo.devPositionMonitorTime
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("添加设备成功");
        this.AddDeviceDialogVisible = false;
        this.getDevice();
      });
    },

    //关闭增加设备信息对话框触发
    clearAddDeviceDialogVisible() {
      this.$refs.addDeviceFormRef.resetFields();
      this.checkDeviceDep = "";
    },

    // 打开修改设备对话框
    OpenUpdateDevicesDialog(data) {
      // 单位id
      this.queryInfo.depId = data.devDepId;
      // 根据单位ID查询人员
      this.GetPerson();
      this.UpdateDeviceDialogVisible = true;
      // 设备编号
      this.UpdateDeviceInfo.devNo = data.devNo;
      // 设备类型
      this.UpdateDeviceInfo.devType = data.devType;
      // 设备协议
      this.UpdateDeviceInfo.devProtocol = data.devProtocol;
      // 单位ID
      this.UpdateDeviceInfo.devDepId = data.devDepId;
      // 选中后的单位名称
      this.checkDeviceDep = data.depName;
      // 选中后的用户名称
      this.checkUser = data.empName;
      // 人员ID
      this.UpdateDeviceInfo.devEmpId = data.devEmpId;
      // 删除需要的设备ID
      this.UpdateDeviceInfo.devId = data.devId;
      // 位置监听是否开启
      this.UpdateDeviceInfo.devPositionMonitorEnable =
        data.devPositionMonitorEnable;
      // 位置监听间隔时间
      this.UpdateDeviceInfo.devPositionMonitorTime =
        data.devPositionMonitorTime;
    },
    //在修改设备选择后人员时获取人员对应单位ID
    getDepIdAsUpdate(empDepId) {
      this.UpdateDeviceInfo.devDepId = empDepId;
    },

    // 当修改设备选中单位时触发
    handleNodeClick3(data) {
      this.UpdateDeviceInfo.devDepId = data.depId;
      this.checkDeviceDep = data.depName;
      this.queryInfo.depId = data.depId;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MyUpdateSelect.handleClose();
    },
    // 修改设备信息
    UpdateDevices() {
      this.$refs.UpdateDeviceFormRef.validate(async valid => {
        if (!valid) return;
        const { data: res } = await this.$axios.put(
          `${this.$api}/device/modify/${this.UpdateDeviceInfo.devId}`,
          {
            devNo: this.UpdateDeviceInfo.devNo,
            devType: this.UpdateDeviceInfo.devType,
            devProtocol: this.UpdateDeviceInfo.devProtocol,
            devDepId: this.UpdateDeviceInfo.devDepId,
            devEmpId: this.UpdateDeviceInfo.devEmpId,
            devPositionMonitorEnable: this.UpdateDeviceInfo
              .devPositionMonitorEnable,
            devPositionMonitorTime: this.UpdateDeviceInfo.devPositionMonitorTime
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.UpdateDeviceDialogVisible = false;
        this.$message.success("修改设备信息成功");
        this.getDevice();
      });
    },
    //关闭修改设备信息对话框触发
    clearUpdateDeviceDialogVisible() {
      this.$refs.UpdateDeviceFormRef.resetFields();
      this.checkDeviceDep = "";
    },

    // 删除设备信息
    async deleteDevices(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该设备, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).catch(err => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/device/delete/${value.devId}`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }

      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryDevice.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryDevice.page === lastPage &&
        this.total % this.queryDevice.pageSize === 1
      ) {
        this.queryDevice.page--; //页码-1
      }

      this.$message.success("已成功删除该设备");
      this.getDevice();
    }
  }
};
</script>

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;

  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 40px 10px 20px 10px;
  height: calc(100vh - 220px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/SystemManagement/deviceManagement.vue